import { RepoFactory } from '@/baseRepository/Factory';
const merchantRepository = () => RepoFactory.get('merchant');
const enumsRepository = () => RepoFactory.get("enums");
export const merchantActions = {
  getCurrentMechantsItems(context) {
    return new Promise((resolve, reject) => {
      merchantRepository()
        .getConfirmedMerchant(`${context.getters.merchantBaseUrl}`)
        .then((res) => {
          context.commit('setCurrentMerchantItems', res.data);
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getCompanyTypeGroups(context) {
    return new Promise((resolve, reject) => {
      if (context.state.companyTypeGroups.length) {
        resolve();
      }
      merchantRepository()
        .getCompanytypegroups(`${context.getters.merchantBaseUrl}`)
        .then((res) => {
          context.commit('setCompanyTypeGroups', res.data);
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getMerchantInformation(context, params) {
    return new Promise((resolve, reject) => {
      merchantRepository()
        .getMerchantByUser(context.getters.merchantBaseUrl,{
          MerchantId: context.getters.currentMerchant
        }, {
          ...params,
        })
        .then((res) => {
          context.commit('setMerchantInformation', res.data);
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getMerchantStatusList(context) {
    return new Promise((resolve, reject) => {
      if (context.state.merchantStatusList.length) {
        resolve(context.state.merchantStatusList);
      }
      enumsRepository()
        .getEnum("MerchantStatus", context.getters.merchantBaseUrl)
        .then((res) => {
          context.commit("setMerchantStatusList", res.data);
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
